'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' });

var SignalCellularNoSim = function SignalCellularNoSim(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SignalCellularNoSim = (0, _pure2.default)(SignalCellularNoSim);
SignalCellularNoSim.muiName = 'SvgIcon';

exports.default = SignalCellularNoSim;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SignalCellularNoSim.js
// module id = 2850
// module chunks = 0